'use client';

import React, { useState, useRef, useEffect } from 'react';
import classNames from 'clsx';
import DoneIcon from '@mui/icons-material/Done';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

interface OptionItem {
  label: string;
  value: any;
  icon?: () => React.ReactNode;
  disabled?: boolean;
}

interface selectProps {
  defaultValue?: string | string[] | number | number[];
  defaultLabel?: string;
  options: Array<OptionItem>;
  onChange?: (e: any) => void;
  children?: React.ReactNode;
  dropDownClassName?: string;
}
const Select = (props: selectProps) => {
  const { defaultValue, defaultLabel, options, onChange, dropDownClassName } =
    props;
  const domRef = useRef<HTMLDivElement>(null);
  const [downModal, setDownModal] = useState(false);
  const [choiceItem, setChoiceItem] = useState<OptionItem>();
  const [showAbove, setShowAbove] = useState<boolean>(false);

  useEffect(() => {
    /** 监听是否点击非元素自身 */
    const handle = (e: MouseEvent) => {
      const isOutside = !domRef.current?.contains(e.target as Node);
      if (isOutside) setDownModal(false);
    };
    document.addEventListener('click', handle);

    const currentOption = options?.find((item) => item.value === defaultValue);
    if (currentOption) setChoiceItem(currentOption);

    //组件卸载时销毁全局监听事件
    return () => {
      document.removeEventListener('click', handle);
    };
  }, []);

  useEffect(() => {
    if (domRef.current) {
      const rect = domRef.current?.getBoundingClientRect();
      const elementBottom = rect?.bottom;
      const viewportHeight = window.innerHeight;
      const distanceToBottom = viewportHeight - elementBottom;

      if (distanceToBottom <= 100) {
        // TODO: show above
        setShowAbove(true);
      }
    }
  }, [domRef.current]);

  const clickItems = (e: any, item: OptionItem) => {
    e.stopPropagation();
    setDownModal(false);
    setChoiceItem(item);
    onChange?.(item.value);
  };

  const clickSelectBox = (e: any) => {
    e.stopPropagation();
    setDownModal(!downModal);
  };

  return (
    <div className="h-[40px] relative" onClick={clickSelectBox} ref={domRef}>
      <div className="h-[40px] flex items-center justify-between select-none cursor-pointer">
        <div className="flex items-center gap-[10px] flex-1 overflow-hidden">
          {choiceItem?.icon?.()}
          <span>{defaultLabel}</span>
        </div>
        <ArrowBackIosIcon
          className={classNames(
            '!size-[16px] transition-transform duration-300 ease-in-out ml-xs',
            downModal ? 'mt-[10px] rotate-90' : 'mt-[-6px] rotate-[270deg]'
          )}
        />
      </div>
      {downModal && (
        <div
          className={`${dropDownClassName || ''} absolute min-w-[200px] p-[5px] left-1/2 -translate-x-1/2 bg-white z-[1000] border-[0.5px] rounded-[12px] border-black-origin/15 ${showAbove ? '-translate-y-[140px]' : ''}`}
          // style={{ top: `${divHeight}px` }}
          style={{
            boxShadow:
              '0px 2px 6px 0px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)'
          }}>
          {options &&
            options.length > 0 &&
            options.map((item) => (
              <div
                className={classNames(
                  'flex items-center justify-between h-[42px] px-[10px] cursor-pointer select-none hover:bg-[#F9FAFB] hover:rounded-[6px]',
                  { 'text-[#006BC6]': item.value === choiceItem?.value }
                )}
                key={item.value}
                onClick={(e) => {
                  if (!item.disabled) clickItems(e, item);
                }}>
                <div className="flex items-center gap-[10px]">
                  <div className="w-[16px] h-[16px] flex-shrink-0 flex items-center">
                    {item.icon?.()}
                  </div>
                  <span>{item.label}</span>
                </div>
                {item.value === choiceItem?.value && (
                  <DoneIcon className="text-[#006BC6]" />
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};
export default Select;
